import React from 'react';
import { Space } from 'antd';
import CustomDropdown from '../../v2-components/Antd/Dropdown';
import CustomButton from '../../v2-components/Antd/Button';
import { getOptionMenu } from './constants/option-menu.constant';
import useNotificationStore from '../../v2-pages/notification/store/useNotificationStore';
export default function MenuProfile(props) {
	const clearToken = useNotificationStore((state) => state.clearToken);
	const optionMenu = getOptionMenu(clearToken);

	return (
		<>
			<CustomDropdown menu={{ items: optionMenu }}>
				<CustomButton onClick={(e) => e.preventDefault()}>
					<Space>Mi Perfil</Space>
				</CustomButton>
			</CustomDropdown>
		</>
	);
}

// export default function MenuProfile(props) {
// 	return (
// 		<>
// 			<CustomDropdown menu={{ items: OPTION_MENU }}>
// 				<CustomButton onClick={(e) => e.preventDefault()}>
// 					<Space>Mi Perfil</Space>
// 				</CustomButton>
// 			</CustomDropdown>
// 		</>
// 	);
// }
